<!-- <template>
  <section class="testimonial">
    <div class="inner">
      <h3>
        <i class="fa fa-thumbs-o-up"></i> Kind words from our happy customers!
      </h3>
      <div class="testimonial-slideshow" data-cycle-auto-height="calc" data-cycle-pager=".testimonial-pager" data-cycle-slides=".testimonial-slide">
        <div class="testimonial-slide">
          <p>
            <i class="fa fa-quote-left"></i> Having searched other wooden gate companies I needed a pair of quality wooden gates quickly and so when I saw these could make and deliver made to measure gates in the height of summer in only 7 working days I was sceptical to say the least, but WOW! These are the best quality gates I could have hoped for. They look amazing and keep my dog safe, would recommend.
            <i class="fa fa-quote-right"></i>
          </p>
        </div>
        <div class="testimonial-slide">
          <p>
            <i class="fa fa-quote-left"></i> Can I just say this company is top quality from start to finish. Their commitment to workmanship and customer service is second to none. I would recomend KP Wooden gates to all.
            <i class="fa fa-quote-right"></i>
          </p>
        </div>
        <div class="testimonial-slide">
          <p>
            <i class="fa fa-quote-left"></i> Impressive gate, 3ft wide plus two side panels to fill 6’6″gap. Four posts, two fastened to side walls, one concreted in soil, the other drilled through 4″ thick path and concreted in! Yale lock for opening either side. Looks good and feels secure. Very professionally installed by Roy &amp; Patrick. Highly recommend.
            <i class="fa fa-quote-right"></i>
          </p>
        </div>
        <div class="testimonial-pager"></div>
      </div>
    </div>
  </section>
</template> -->

<template>
  <section class="testimonial" v-if="testimonials">
    <div class="inner">
      <h3>
        <i class="fa fa-thumbs-o-up"></i> Kind words from our happy customers!
      </h3>
      <div class="testimonial-slideshow" data-cycle-auto-height="calc" data-cycle-pager=".testimonial-pager" data-cycle-slides=".testimonial-slide">
        <div :key="test._id" class="testimonial-slide" v-for="test in testimonials">
          <p v-html="quoteText(test.quote)"></p>
        </div>
        <div class="testimonial-pager"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Testimonials",
  computed: {
    testimonials: function() {
      return this.$store.state.testimonials
    }
  },
  methods: {
    quoteText: function(quote) {
      return "<i class='fa fa-quote-left'></i>" + quote.replace('<p>','').replace('</p>','') + "<i class='fa fa-quote-right'></i>"
    }
  }
}
</script>

<style scoped>
.testimonial {
  margin-bottom: 0;
  background: rgba(67, 79, 80, 0.11);
  padding: 5rem 0;
  text-align: center;
  margin-top: 5rem;
}

.testimonial .cycle-slidehow,
.testimonial-slide {
  width: 100%;
}

.testimonial p {
  display: block;
  margin: auto;
  width: 90%;
  max-width: 1000px;
  font-size: 2rem;
}

.testimonial h3 {
  font-size: 2.5rem;
  line-height: 1.5;
}

.testimonial h3 i {
  margin-right: 0.5rem;
}

.testimonial-pager {
  color: #434f50;
  font-size: 3rem;
  z-index: 999;
  bottom: 7%;
}

</style>
